// Secure Files — appels réseau. Aucun de ces appels ne transporte la clé, le nom, le MIME ou le destinataire.
import { api, publicApi } from "../api";
import { buildUploadForm } from "./crypto";

export const fetchSecureFilesConfig = () => api.get("/secure-files/config").then((r) => r.data);
export const listSecureFiles = () => api.get("/secure-files").then((r) => r.data);
export const revokeSecureFile = (id) => api.delete(`/secure-files/${id}`).then((r) => r.data);

export const uploadSecureFile = (encrypted, expiration, onProgress) =>
  api.post("/secure-files", buildUploadForm(encrypted, expiration), {
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  }).then((r) => r.data);

export const fetchSecureFileMeta = (token) => publicApi.get(`/f/${token}`).then((r) => r.data);

export const downloadSecureFileCiphertext = (token) =>
  publicApi.post(`/f/${token}/download`, null, { responseType: "arraybuffer" }).then((r) => r.data);

// Code d'erreur stable (detail.code), y compris pour une réponse binaire (arraybuffer).
export function secureFileErrorCode(e) {
  let d = e?.response?.data;
  if (d instanceof ArrayBuffer) {
    try { d = JSON.parse(new TextDecoder().decode(d)); } catch (_) { d = null; }
  }
  if (!e?.response) return "NETWORK";
  return d?.detail?.code || (e.response.status === 413 ? "FILE_TOO_LARGE" : "UNKNOWN");
}
